import { Middleware } from 'redux';
import { AGREEMENT, ENVIRONMENT } from 'core/datasets/action';
import { AppState } from 'core/redux/rootReducer';
import agreementSelectors from '../../../agreement/redux/agreementSelectors';
import { environmentActions } from '../environmentActions';
import { getEnvironmentSettingsDocument } from '../../gql/getEnvironmentSettingsDocument';

const environmentMiddleware: Middleware =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);

        const state: AppState = getState();

        switch (action?.type) {
            case AGREEMENT.FETCH_AGREEMENTS_ASYNC: {
                const selectedAgreementId = agreementSelectors.selectedAgreementId(state);

                if (selectedAgreementId)
                    dispatch(
                        environmentActions.fetchEnvironmentSettingsRequest(
                            getEnvironmentSettingsDocument,
                            ENVIRONMENT.SET_ENVIRONMENT_SETTINGS,
                            selectedAgreementId,
                        ),
                    );
                break;
            }

            case AGREEMENT.AGREEMENT_SELECTED: {
                const selectedAgreementId = agreementSelectors.selectedAgreementId(state);

                if (selectedAgreementId)
                    dispatch(
                        environmentActions.fetchEnvironmentSettingsRequest(
                            getEnvironmentSettingsDocument,
                            ENVIRONMENT.SET_ENVIRONMENT_SETTINGS,
                            selectedAgreementId,
                        ),
                    );
                break;
            }

            default:
                break;
        }
    };

export default environmentMiddleware;
